var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit-purchasable-item"}},[_c('h2',[_vm._v("Edit Purchasable Item #"+_vm._s(_vm.purchasableItemId))]),_vm._v(" "),_c('purchasable-item-form',{attrs:{"purchasableItemId":_vm.purchasableItemId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6965a974","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchasableItemEdit.vue
// module id = 1220
// module chunks = 1